import React from 'react';
import { css } from '@emotion/css';

const loadingComponentStyle = css`
  display: flex;
  min-height: 20vh;
  align-items: center;
  justify-content: center;
  color: #2a2928;
`;
const LoadingComponent = () => {
  return <div className={loadingComponentStyle}>loading items...</div>;
};
export default LoadingComponent;
